import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getCashiersProfile = (params) => {
    return axios.get(`${backendHost}/api/admin/cashiers/view`, {params});
};

export {
    getCashiersProfile
}